import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//路由重写---解决重定向问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

//路由重写---解决重定向问题
const originalPush1 = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush1.call(this, location, onResolve, onReject)
  return originalPush1.call(this, location).catch(err => err)
}

export const constantRoutes = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: "首页",
      color: '#0071ee',
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/index")
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: "登录",
      color: "#ffffff",
      keepAlive: true,
    },
    component: () => import("@/views/login/index")
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: "首页",
      color: '#0071ee'
    },
    component: () => import("@/views/home/index")
  },
  {
    path: '/product',
    name: 'product',
    meta: {
      title: "产品中心",
      color: "#ffffff"
    },
    component: () => import("@/views/product/index")
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    meta: {
      title: "产品详情",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
      tabActive: 0,
    },
    component: () => import("@/views/product/productDetail")
  },
  {
    path: '/shopIndex',
    name: 'shopIndex',
    meta: {
      title: "商城",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0
    },
    component: () => import("@/views/product/shop/shopIndex")
  },
  {
    path: '/commodityDetail',
    name: 'commodityDetail',
    meta: {
      title: "商品详情",
      color: "#ffffff"
    },
    component: () => import("@/views/product/shop/commodityDetail")
  },
  {
    path: '/productCenter',
    name: 'productCenter',
    meta: {
      title: "产品中心",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0
    },
    component: () => import("@/views/product/productCenter")
  },
  {
    path: '/apply',
    name: 'apply',
    meta: {
      title: "应用",
      color: '#0071ee'
    },
    component: () => import("@/views/apply/index")
  },
  {
    path: '/applyIntro',
    name: 'applyIntro',
    meta: {
      title: "应用介绍",
      color: '#0071ee'
    },
    component: () => import("@/views/apply/appIntro")
  },
  {
    path: '/subApp',
    name: 'subApp',
    meta: {
      title: ""
    },
    component: () => import("@/views/apply/subApp")
  },
  {
    path: '/school',
    name: 'school',
    meta: {
      title: "环保学堂",
      color: '#0071ee'
    },
    component: () => import("@/views/school/index")
  },
  {
    path: '/my',
    name: 'my',
    meta: {
      title: "我的",
      color: "#ffffff",
    },
    component: () => import("@/views/my/index")
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    meta: {
      title: "个人资料",
      color: "#ffffff",
    },
    component: () => import("@/views/my/info/userInfo")
  },
  {
    path: '/changeNickname',
    name: 'changeNickname',
    meta: {
      title: "编辑昵称",
      color: "#ffffff",
    },
    component: () => import("@/views/my/info/changeNickname")
  },
  {
    path: '/authEnterprise',
    name: 'authEnterprise',
    meta: {
      title: "企业认证",
      color: "#ffffff",
    },
    component: () => import("@/views/my/info/authEnterprise")
  },
  {
    path: '/authEmployee',
    name: 'authEmployee',
    meta: {
      title: "内部员工认证",
      color: "#ffffff",
      keepAlive: true,
    },
    component: () => import("@/views/my/info/authEmployee")
  },
  {
    path: '/authEmployeeBindPhone',
    name: 'authEmployeeBindPhone',
    meta: {
      title: "绑定手机号",
      color: "#ffffff",
    },
    component: () => import("@/views/my/info/authEmployeeBindPhone")
  },
  {
    path: '/myDownload',
    name: 'myDownload',
    meta: {
      title: "我的下载",
      color: "#ffffff",
    },
    component: () => import("@/views/my/myDownload")
  },
  {
    path: '/myCollection',
    name: 'myCollection',
    meta: {
      title: "我的收藏",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0
    },
    component: () => import("@/views/my/myCollection")
  },
  {
    path: '/myRecentRead',
    name: 'myRecentRead',
    meta: {
      title: "最近浏览",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0
    },
    component: () => import("@/views/my/myRecentRead")
  },
  {
    path: '/previewPdf',
    name: 'previewPdf',
    meta: {
      title: "文件预览",
      color: "#ffffff",
    },
    component: () => import("@/views/my/previewPdf")
  },
  {
    path: '/setting',
    name: 'setting',
    meta: {
      title: "设置",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/index")
  },
  {
    path: '/accountAuth',
    name: 'accountAuth',
    meta: {
      title: "账号授权",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/children/accountAuth")
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: "关于我们",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/children/aboutUs")
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: {
      title: "意见反馈",
      color: "#ffffff",
    },
    component: () => import("@/views/my/feedback")
  },
  {
    path: '/serviceArea',
    name: 'serviceArea',
    meta: {
      title: "服务专区",
      color: "#ffffff",
    },
    component: () => import("@/views/my/service/serviceArea")
  },
  {
    path: '/orderService',
    name: 'orderService',
    meta: {
      title: "预约服务",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/my/service/orderService")
  },
  {
    path: '/maintenanceService',
    name: 'maintenanceService',
    meta: {
      title: "维保服务",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/my/service/maintenanceService")
  },
  {
    path: '/maintenaceRecord',
    name: 'maintenaceRecord',
    meta: {
      title: "维保记录",
      color: "#ffffff",
    },
    component: () => import("@/views/my/service/children/maintenaceRecord")
  },
  {
    path: '/productSelector',
    name: 'productSelector',
    meta: {
      title: "选择产品",
      color: "#ffffff",
    },
    component: () => import("@/views/my/service/children/productSelector")
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    meta: {
      title: "常见问题",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/my/service/FAQ")
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      title: "搜索",
      color: "#ffffff",
    },
    component: () => import("@/views/search/index")
  },
  {
    path: '/searchResult',
    name: 'searchResult',
    meta: {
      title: "搜索",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/search/searchResult")
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {
      title: "消息中心",
      color: "#ffffff",
    },
    component: () => import("@/views/notice/noticeType")
  },
  {
    path: '/noticeList',
    name: 'noticeList',
    meta: {
      title: "消息列表",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/notice/index")
  },
  {
    path: '/noticeDetails',
    name: 'noticeDetails',
    meta: {
      title: "消息详情",
      color: "#ffffff",
    },
    component: () => import("@/views/notice/details")
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    meta: {
      title: "忘记密码",
      color: "#ffffff",
    },
    component: () => import("@/views/login/forgotPassword/index")
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: "注册",
      color: "#ffffff",
      keepAlive: true,
    },
    component: () => import("@/views/login/register/index")
  },
  {
    path: '/privacyAgreementPage',
    name: 'privacyAgreementPage',
    meta: {
      title: "隐私协议",
      color: "#ffffff",
    },
    component: () => import("@/views/login/privacyAgreementPage")
  },
  {
    path: '/userAgreementPage',
    name: 'userAgreementPage',
    meta: {
      title: "用户协议",
      color: "#ffffff",
    },
    component: () => import("@/views/login/userAgreementPage")
  },
  {
    path: '/DTHBPage',
    name: 'DTHBPage',
    meta: {
      title: "低碳环保",
      color: "#0071ee",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/DTHB/index")
  },
  {
    path: '/DTHBPageDetails',
    name: 'DTHBPageDetails',
    meta: {
      title: "低碳环保详情",
      color: "#ffffff",
    },
    component: () => import("@/views/home/DTHB/details")
  },
  {
    path: '/newsSecretary',
    name: 'newsSecretary',
    meta: {
      title: "新闻小秘书",
      color: '#0071ee',
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/XWXMS/index")
  },
  {
    path: '/newsSecretaryDetails',
    name: 'newsSecretaryDetails',
    meta: {
      title: "新闻小秘书详情",
      color: "",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/XWXMS/details")
  },
  {
    path: '/HYXWPage',
    name: 'HYXWPage',
    meta: {
      title: "行业新闻",
      color: '#0071ee',
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/HYXW/index")
  },
  {
    path: '/derunHome',
    name: 'derunHome',
    meta: {
      title: "德润之家",
      color: '#0071ee',
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/derunHome")
  },
  {
    path: '/numberAndSecurity',
    name: 'numberAndSecurity',
    meta: {
      title: "账号与安全",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/numberAndSecurity/index")
  },
  {
    path: '/updatePhone',
    name: 'updatePhone',
    meta: {
      title: "账号与安全",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/numberAndSecurity/updatePhone")
  },
  {
    path: '/bindPhone',
    name: 'bindPhone',
    meta: {
      title: "账号与安全",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/numberAndSecurity/bindPhone")
  },
  {
    path: '/setPass',
    name: 'setPass',
    meta: {
      title: "密码",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/numberAndSecurity/setPass")
  },
  {
    path: '/modifyPass',
    name: 'modifyPass',
    meta: {
      title: "设置密码",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/numberAndSecurity/modifyPass")
  },
  {
    path: '/modifyPassSuccess',
    name: 'modifyPassSuccess',
    meta: {
      title: "修改密码",
      color: "#ffffff",
    },
    component: () => import("@/views/my/set/numberAndSecurity/modifyPassSuccess")
  },
  {
    path: '/kefu',
    name: 'kefu',
    meta: {
      title: "在线客服",
      color: "#0071ee",
    },
    component: () => import("@/views/kefu")
  },
  {
    path: '/applicationMage',
    name: 'applicationMage',
    meta: {
      title: "首页应用管理",
      color: "#0071ee",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/applicationMage/index")
  },
  {
    path: '/ZLKPage',
    name: 'ZLKPage',
    meta: {
      title: "资料库",
      color: "#0071ee",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/ZLK/index")
  },
  {
    path: '/BZJDPage',
    name: 'BZJDPage',
    meta: {
      title: "标准解读",
      color: "#0071ee",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/BZJD/index")
  },
  {
    path: '/PXTDPage',
    name: 'PXTDPage',
    meta: {
      title: "培训天地",
      color: "#0071ee",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/PXTD/index")
  },
  {
    path: '/ZJFXPage',
    name: 'ZJFXPage',
    meta: {
      title: "专家分享",
      color: "#0071ee",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/ZJFX/index")
  },
  {
    path: '/KCYXPage',
    name: 'KCYXPage',
    meta: {
      title: "我的课程",
      color: '#0071ee',
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/KCYX/index")
  },
  {
    path: '/KCYXDetails',
    name: 'KCYXDetails',
    meta: {
      title: "我的课程详情",
      color: "",
    },
    component: () => import("@/views/school/schoolCommon/KCYX/details")
  },
  {
    path: '/scan',
    name: 'scan',
    meta: {
      title: "",
      color: '#0071ee'
    },
    component: () => import("@/views/scan")
  },
  {
    path: '/ZBTJPage',
    name: 'ZBTJPage',
    meta: {
      title: "直播广场",
      color: '#0071ee',
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/home/ZBTJ/index")
  },
  {
    path: '/ZBTJPageDetails',
    name: 'ZBTJPageDetails',
    meta: {
      title: "直播广场详情",
      color: ''
    },
    component: () => import("@/views/school/schoolCommon/ZBTJ/details")
  },
  {
    path: '/comonDetailsPage',
    name: 'comonDetailsPage',
    meta: {
      title: "",
      color: "#ffffff",
    },
    component: () => import("@/views/search/comonDetailsPage")
  },
  {
    path: '/DRXCPPage',
    name: 'DRXCPPage',
    meta: {
      title: "德润宣传",
      color: "#0071ee",
    },
    component: () => import("@/views/home/derunHome/DRXCP/index")
  },
  {
    path: '/commonArticleDetails',
    name: 'commonArticleDetails',
    meta: {
      title: "文章详情",
      color: "",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/common/article/commonArticleDetails")
  },
  {
    path: '/childrenSystemPage',
    name: 'childrenSystemPage',
    meta: {
      title: "",
      color: "#0071ee",
    },
    component: () => import("@/views/notice/childrenSystemPage")
  },
  {
    path: '/picturePreview',
    name: 'picturePreview',
    meta: {
      title: "图片预览",
      color: "#0071ee",
    },
    component: () => import("@/views/home/derunHome/RYZZ/picturePreview")
  },
  {
    path: '/orderRecord',
    name: 'orderRecord',
    meta: {
      title: "预约记录",
      color: "#ffffff",
    },
    component: () => import("@/views/my/service/children/orderRecord")
  },
  // --------- 德润员工内部入口 -----------
  {
    path: '/drIndex',
    name: 'drIndex',
    meta: {
      title: "首页",
      color: "#0071ee",
    },
    component: () => import("@/views/derun/Index")
  },
  // --------- 绩效表 -----------
  {
    path: '/myKBI',
    name: 'myKBI',
    meta: {
      title: "我的考核",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/kbi/myKBI")
  },
  {
    path: '/myKBIHistory',
    name: 'myKBIHistory',
    meta: {
      title: "历史考核",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/kbi/myKBIHistory")
  },
  {
    path: '/KBIManage',
    name: 'KBIManage',
    meta: {
      title: "考核管理",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/derun/kbi/KBIManage")
  },
  {
    path: '/KBIRecord',
    name: 'KBIRecord',
    meta: {
      title: "上传记录",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/kbi/UploadRecord")
  },
  {
    path: '/KBIStatistic',
    name: 'KBIStatistic',
    meta: {
      title: "考核统计表",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/kbi/KBIStatistic")
  },
  // ----------- 营销素材 -----------------
  {
    path: '/myMaterial',
    name: 'myMaterial',
    meta: {
      title: "我的素材",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/derun/material/myMaterial")
  },
  {
    path: '/materialUpload',
    name: 'materialUpload',
    meta: {
      title: "上传素材",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/derun/material/upload")
  },
  {
    path: '/materialDetail',
    name: 'materialDetail',
    meta: {
      title: "素材详情",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/derun/material/materialDetail")
  },
  {
    path: '/materialRecycleBin',
    name: 'materialRecycleBin',
    meta: {
      title: "素材回收站",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/material/recycleBin")
  },
  {
    path: '/materialResource',
    name: 'materialResource',
    meta: {
      title: "素材资料",
      color: "#ffffff",
      keepAlive: true,
      scollTopPosition: 0,
    },
    component: () => import("@/views/derun/material/materialResource")
  },
  {
    path: '/materialSearch',
    name: 'materialSearch',
    meta: {
      title: "素材搜索",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/material/search")
  },
  {
    path: '/materialPoint',
    name: 'materialPoint',
    meta: {
      title: "素材积分",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/material/myPoint")
  },
  {
    path: '/materialPointDetail',
    name: 'materialPointDetail',
    meta: {
      title: "积分明细",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/material/myPointDetail")
  },
  {
    path: '/filePreview',
    name: 'filePreview',
    meta: {
      title: "文件预览",
      color: "#ffffff",
    },
    component: () => import("@/views/derun/material/filePreview")
  },
  // 文件资料
  {
    path: '/fileResource',
    name: 'fileResource',
    meta: {
      title: '文件资料',
      color: '#ffffff',
      keepAlive: true, //需要缓存
      scollTopPosition: 0,
    },
    component: () => import('@/views/derun/fileResource/index.vue'),
  },
  {
    path: '/fileResourceList',
    name: 'fileResourceList',
    meta: {
      title: '文件资料',
      color: '#ffffff',
      keepAlive: true, //需要缓存
      scollTopPosition: 0,
    },
    component: () => import('@/views/derun/fileResource/fileList.vue'),
  },
  {
    path: '/fileResourceRecycleBin',
    name: 'fileResourceRecycleBin',
    meta: {
      title: '文件回收站',
      color: '#ffffff',
    },
    component: () => import('@/views/derun/fileResource/recycleBin.vue'),
  },
  {
    path: '/fileResourceSearch',
    name: 'fileResourceSearch',
    meta: {
      title: '文件搜索',
      color: '#ffffff',
      keepAlive: true, //需要缓存
      scollTopPosition: 0,
    },
    component: () => import('@/views/derun/fileResource/fileSearch.vue'),
  },
  //库存管理
  {
    path: '/inventoryLook',
    name: 'inventoryLook',
    meta: {
      title: '查看库存',
      color: '#ffffff',
      keepAlive: true, //需要缓存
      scollTopPosition: 0,
    },
    component: () => import('@/views/derun/inventory/inventoryLook.vue'),
  },
]


//创建路由---回到顶部
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior (to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: constantRoutes
})

const router = createRouter()

import {
  getLoginStatusByToken
} from '@/request/login.js'
import androidinfo from '@/utils/androidinfo'
import { getToken, getUserId, getPhone, getOfficeToken, getUserName } from '@/utils/utils'
router.beforeEach((to, from, next) => {
  try {
    androidinfo.changeStatusBarTextColor(to.meta.color == '#ffffff')
  } catch (error) {

  }
  if (process.env.NODE_ENV == 'development') {
    // localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJrZXkiOiJ7XCJjcmVhdGVUaW1lXCI6MTY3MzQ4Njg0OTAwMCxcImNyZWF0ZXJcIjpcIlwiLFwiZW1haWxcIjpcIlwiLFwiaWRcIjpcIjhiYzk5OTRkLWZhYTUtNDViZC04NWI1LTc0ZWUwYjc2YzlmNVwiLFwibWVudXNcIjpbXSxcIm5hbWVcIjpcIjEzMzE1MTA0NTEwXCIsXCJwYXNzd29yZFwiOlwiXCIsXCJwaG9uZVwiOlwiMTMzMTUxMDQ1MTBcIixcInJvbGVcIjpbXSxcInVwZGF0ZVRpbWVcIjoxNjczNDg2ODQ5MDAwLFwidXBkYXRlclwiOlwiXCIsXCJ1c2VyVHlwZVwiOlwiXCIsXCJ1c2VybmFtZVwiOlwiXCJ9IiwiZXhwIjoxNzA1MjIwODA0fQ.Q3-rZz1boVQSnMU_c005BoAo35mPJAb7RAVMFUWPyIQ")
  }
  if (to.path === '/login' || to.path === '/register'
    || to.path === '/forgotPassword' || to.path === '/userAgreementPage'
    || to.path === '/privacyAgreementPage' || to.path === '/productCenter') {
    next()
  } else {
    let isDRAPP = !(location.href.indexOf('share=1') > -1)
    if (getToken()) {
      try {
        androidinfo.setToken(getToken())
        androidinfo.setOfficeToken(getOfficeToken())
        androidinfo.setUserId(getUserId())
        androidinfo.setUserName(getUserName())
        androidinfo.setPhone(getPhone())
        androidinfo.setOfficeToken(getOfficeToken())
      } catch (error) {
      }
      sessionStorage.setItem('play_time', 0)
      next()
    } else {
      //是否在德润app中，isDRAPP:true
      if (isDRAPP) {
        next('/login')
      } else {
        sessionStorage.setItem('play_time', 0)
        next()
      }
    }
  }
})
function getLoginStatus (to, from, next) {
  getLoginStatusByToken(
    {
      token: getToken()
    }
  ).then(res => {
    if (res.code == 0) {
      if (res.data.status == 'on') {
        next()
      } else {
        next('/login')
      }
    } else {
      this.$toast(res.msg)
    }
  })
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js